import React from 'react';
import ResendAction from './Actions/ResendAction';
import CancelAction from './Actions/CancelAction';
import RescheduledAction from './Actions/RescheduleAction';

import { Can } from '../../../../_contexts/AbilitiesContext'

export default function SentActions({ loadData, telehealth }) {
  return <div>
    <Can I="schedule" a="telehealth">
      <ResendAction loadData={loadData} telehealth={telehealth} />
      &nbsp;
    </Can>

    <Can I="reschedule" a="telehealth">
      <RescheduledAction telehealth={telehealth} />
      &nbsp;
    </Can>

    <Can I="cancel" a="telehealth">
      <CancelAction telehealth={telehealth} />
    </Can>
  </div>
}